import React, { useState, useCallback, useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import * as selector from '../../selectors/selectors';
import { Group } from '../../models/conversations';
import CustomSwitch from '../shared/switch.component';
import { CampaignHistoryMsgIconHover, CancelIcon, DateIcon, DeleteMessageIcon, DesktopPreviewIcon, DragHolderIcon, FalconLogo, LockGrayIcon, MailIcon, MobilePreviewIcon, PlusPrimaryIcon, UploadFileIcon, UploadIcon } from '../../icon';
import Avatar from '../shared/avatar.component';
import { Autocomplete, Checkbox, InputAdornment, TextField } from '@mui/material';
import { CustomAttributeDefinitionModel, CustomAttributeType, FIELD_TYPE_LABELS, numberToFieldType } from '../../models/custom-attribute.model';
import ButtonComponent from '../shared/button/button.component';
import { WebFormService } from '../../services/WebFormService';
import { PhoneNumberModel } from '../../models/phone-number.model';
import { UtilityService } from '../../services/UtilityService';
import { GroupContactService } from '../../services/GroupContactService';
import { UserService } from '../../services/UserService';
import { MediaModel } from '../../models/templates.models';
import { WebFormModel, WebFormStatus } from '../../models/web-form.model';
import { buttonLabels, ToasterTexts } from '../shared/constants';
import setToast from '../../helpers/toaster.helper';
import { ToasterType } from '../shared/toaster/toaster.model';


const DRAG_TYPE = 'web-form-field';

interface DragPayload {
    source: 'selected' | 'unselected';
    index: number;
    field: CustomAttributeDefinitionModel;
}

const DefalitFileds: { id: string; label: string; required: boolean; }[] = [
    { id: 'firstName', label: 'First Name', required: true, },
    { id: 'lastName', label: 'Last Name', required: false, },
    { id: 'phone', label: 'Phone Number', required: true, },
    { id: 'email', label: 'Email Address', required: false, },
    { id: 'consent', label: 'Consent Checkbox', required: true, },
];

const Fileds: CustomAttributeDefinitionModel[] = [
    { Id: 'FirstName', Name: 'First Name', IsRequired: true, Reference: '', Type: 0 },
    { Id: 'LastName', Name: 'Last Name', IsRequired: false, Reference: '', Type: 0 },
    { Id: 'PhoneNumber', Name: 'Phone Number', IsRequired: true, Reference: '', Type: CustomAttributeType.Phone },
    { Id: 'Email', Name: 'Email Address', IsRequired: false, Reference: '', Type: CustomAttributeType.Email },
    { Id: 'Consent', Name: 'Consent Checkbox', IsRequired: true, Reference: '', Type: 0 },
];

interface IProps {
    WebForm: WebFormModel;
    onClose: () => void;
}

const WebFormViewComponent = (props: IProps) => {
    const iconRef = useRef<HTMLInputElement | null>(null);

    const IsDarkMode: boolean = useSelector(selector.isDarkMode);
    const Groups: Group[] = useSelector(selector.groups) || [];
    const CustomAttributeFields: CustomAttributeDefinitionModel[] = useSelector(selector.customAttributeFields);
    const PhoneNumbersData: PhoneNumberModel[] = useSelector(selector.phoneNumbers)
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)

    const [uploadLogo, setUploadLogo] = useState<{ File: File, Url: string }>()
    const [isMobilePreview, setIsMobilePreview] = useState<boolean>(true)
    const [privacyUrl, setPrivacyUrl] = useState<string>(props.WebForm?.PrivacyPolicyUrl ?? "");
    const [termsServiceUrl, setTermsServiceUrl] = useState<string>(props.WebForm?.TermsConditionUrl ?? "");
    const [selectedGroups, setSelectedGroups] = useState<{ GroupId: string, GroupName: string, PhoneNumber: string }[]>(props.WebForm?.SelectedGroups ?? []);
    const [selectedPhonenmbers, SetSelectedPhonenumbers] = useState<string[]>(props.WebForm?.PhoneNumbers ?? []);
    const [title, setTitle] = useState<string>(props.WebForm?.Title ?? "");
    const [description, setDescription] = useState<string>(props.WebForm?.Description ?? "");
    const [buttonLabel, setButtonLabel] = useState<string>(props.WebForm?.ButtonLabel ?? "Subscribe");
    const [groups, setGroups] = useState<{ GroupId: string, GroupName: string, PhoneNumber: string }[]>([])
    const [Icon, setIcon] = useState<MediaModel>(props?.WebForm?.Logo)
    const [id, setId] = useState<string>(props.WebForm?.Id)
    const [selectedFields, setSelectedFields] = useState<CustomAttributeDefinitionModel[]>(props.WebForm?.CustomContactAttributes ?? [])
    const [unSelectedFields, setUnSelectedFields] = useState<CustomAttributeDefinitionModel[]>([])
    const [isLoadingDraft, setIsLoadingDraft] = useState<boolean>(false)
    const [isLoadingPublish, setIsLoadingPublish] = useState<boolean>(false)
    const [titleError, setTitleError] = useState<string>("")
    const [descriptionError, setDescriptionError] = useState<string>("")
    const [privacyUrlError, setPrivacyUrlError] = useState<string>("")
    const [termsServiceUrlError, setTermsServiceUrlError] = useState<string>("")
    const [phoneNumbersError, setPhoneNumbersError] = useState<string>("")
    const [buttonLabelError, setButtonLabelError] = useState<string>("")

    useEffect(() => {
        if (props.WebForm?.Id) {
            const ids = props.WebForm?.CustomContactAttributes.map(x => x.Id) ?? []
            const field = [...props.WebForm?.CustomContactAttributes, ...Fileds]
            const result = props.WebForm?.FieldIdsOrder.map(id => field.find(item => item.Id?.toLowerCase() === id.toLowerCase())).filter(Boolean); // remove undefined if not found
            setSelectedFields(result)
            setUnSelectedFields(CustomAttributeFields.filter(x => !ids.includes(x.Id)))
        }
        else {
            setUnSelectedFields([])
            setSelectedFields([...Fileds.filter(x => x.Id !== "Consent"), ...CustomAttributeFields, ...Fileds.filter(x => x.Id === "Consent")])
        }
    }, [CustomAttributeFields, props.WebForm])

    useEffect(() => {
        if (!!props.WebForm?.Id) {
            if (props.WebForm?.PhoneNumbers?.length === 1 && props.WebForm?.PhoneNumbers[0] === UserService.getUserPhoneNumber()) {
                setGroups(Groups.map(x => { return { GroupId: x.ID, GroupName: x.Name, PhoneNumber: UserService.getUserPhoneNumber() } }))
            } else {
                GroupContactService.getGroupByPhoneNumbers(props.WebForm?.PhoneNumbers.map(x => x)).then((res) => {
                    setGroups(res.data.map(x => { return { GroupId: x.id, GroupName: x.name, PhoneNumber: x.partationKey } }))
                }).catch((err) => {

                })
            }
        }
    }, [props.WebForm])

    const setSelectedRequired = useCallback((index: number, required: boolean) => {
        setSelectedFields((prev) => {
            const next = [...prev];
            next[index] = { ...next[index], IsRequired: required };
            return next;
        });
    }, [selectedFields]);

    const handleDragStart = useCallback((e: React.DragEvent, source: 'selected' | 'unselected', index: number) => {
        const list = source === 'selected' ? selectedFields : unSelectedFields;
        const field = list[index];
        if (!field) return;
        const payload: DragPayload = { source, index, field };
        e.dataTransfer.setData(DRAG_TYPE, JSON.stringify(payload));
    }, [selectedFields, unSelectedFields]);

    const handleDragOver = useCallback((e: React.DragEvent) => {
        e.preventDefault();
    }, []);

    const handleDrop = useCallback((e: React.DragEvent, targetList: 'selected' | 'unselected', targetIndex: number) => {
        e.preventDefault();
        const raw = e.dataTransfer.getData(DRAG_TYPE);
        if (!raw) return;
        const { source, index: sourceIndex, field } = JSON.parse(raw) as DragPayload;
        // Dragging inside selected order change
        if (source === targetList && source === 'selected') {
            if (sourceIndex === targetIndex) return;
            setSelectedFields((prev) => {
                const next = [...prev];
                const [removed] = next.splice(sourceIndex, 1);
                next.splice(selectedFields?.length - 1 === targetIndex ? targetIndex - 1 : targetIndex, 0, removed);
                return next;
            });
            return;
        }

        // Dragging inside unselected order change
        // if (source === targetList && source === 'unselected') {
        //     if (sourceIndex === targetIndex) return;
        //     setUnSelectedFields((prev) => {
        //         const next = [...prev];
        //         const [removed] = next.splice(sourceIndex, 1);
        //         next.splice(targetIndex, 0, removed);
        //         return next;
        //     });
        //     return;
        // }

        // // Dragging unselected to selected
        // if (source === 'unselected' && targetList === 'selected') {
        //     setUnSelectedFields((prev) => prev.filter((_, i) => i !== sourceIndex));
        //     setSelectedFields((prev) => {
        //         const next = [...prev];
        //         next.splice(Math.min(targetIndex, next.length), 0, field);
        //         return next;
        //     });
        //     return;
        // }

        // // Dragging selected to unselected
        // if (source === 'selected' && targetList === 'unselected') {
        //     setSelectedFields((prev) => prev.filter((_, i) => i !== sourceIndex));
        //     setUnSelectedFields((prev) => {
        //         const next = [...prev];
        //         next.splice(Math.min(targetIndex, next.length), 0, field);
        //         return next;
        //     });
        // }
    }, [selectedFields, unSelectedFields]);


    const addFieldToSelect = (selectedRow: CustomAttributeDefinitionModel, index: number) => {
        const row = CustomAttributeFields.find(x => x.Id === selectedRow.Id)
        const insertIndex = Math.max(selectedFields.length - 1, 0);

        const updatedSelectedFields = [
            ...selectedFields.slice(0, insertIndex),
            row,
            ...selectedFields.slice(insertIndex)
        ];

        setSelectedFields(updatedSelectedFields);
        setUnSelectedFields(unSelectedFields.filter((x, ind) => ind !== index))
    }

    const addFieldToUnSelect = (selectedRow: CustomAttributeDefinitionModel, index: number) => {
        const row = CustomAttributeFields.find(x => x.Id === selectedRow.Id)
        setUnSelectedFields([...unSelectedFields, row])
        setSelectedFields(selectedFields.filter((x, index) => x.Id !== selectedRow.Id))
    }

    const renderFieldRow = (x: CustomAttributeDefinitionModel, index: number, list: 'selected' | 'unselected', isUnselected: boolean) => (
        <div key={x.Id}
            className={`d-flex align-center mt-1 py-1 px-2  bg-color-report-background br-2`}
            draggable={x.Id !== "Consent"}
            onDragStart={(e) => handleDragStart(e, list, index)}
            onDragOver={(e) => handleDragOver(e)}
            onDrop={(e) => handleDrop(e, list, index)}
        >
            <span className="c-pointer mr-1" aria-label="Drag to reorder">
                {x.Id !== "Consent" ? <DragHolderIcon className="w-3" /> : <LockGrayIcon className="w-3" />}
            </span>
            <Avatar Size={30} Index={index} Name={x.Name} />
            <div className={"flex-grow-1 ml-1"}>
                <div className=" h5-medium color-primary-accent">
                    {x.Name}
                </div>
                <div className='h7-regular'>{!x?.Reference ? "Standard field" : "Custom attribute"}</div>
            </div>
            <span className='border-primary-divider px-1 br-1 h-2 d-flex align-center'>{FIELD_TYPE_LABELS[numberToFieldType(x.Type)]}</span>
            {!isUnselected && (
                <span className="d-flex align-center">
                    <span className="h6-regular color-secondary-accent mx-1">{x.IsRequired ? 'Required' : 'Optional'}</span>
                    <div className={`${!x.Reference ? "disabled" : ""}`}>
                        <CustomSwitch
                            checked={x.IsRequired}
                            onChange={(checked) => setSelectedRequired(index, checked)}
                        />
                    </div>
                </span>
            )}
            {isUnselected ? <PlusPrimaryIcon className='c-pointer' onClick={() => { addFieldToSelect(x, index) }} /> : !!x.Reference ? <DeleteMessageIcon className='ml-1 c-pointer' onClick={() => addFieldToUnSelect(x, index)} /> : <LockGrayIcon className='ml-1' />}
        </div>
    );

    const renderEmptyDropZone = (list: 'selected' | 'unselected') => (
        <div className={`d-flex align-center justify-center py-3 px-2 br-2`}
            onDragOver={(e) => { e.preventDefault(); }}
            onDrop={(e) => handleDrop(e, list, 0)}
        >
            <span className="h6-regular color-secondary-accent">No fields available.</span>
        </div>
    );


    const handleSelectedPhoneNumbers = (val: PhoneNumberModel) => {
        if (!!val) {            
            const value = [val]
            setSelectedGroups([])
            SetSelectedPhonenumbers(value.map(x => x.PhoneNumber));
            setPhoneNumbersError("")
            if (value?.length === 1 && value[0]?.PhoneNumber === UserService.getUserPhoneNumber()) {
                setGroups(Groups.map(x => { return { GroupId: x.ID, GroupName: x.Name, PhoneNumber: UserService.getUserPhoneNumber() } }))
            } else {
                GroupContactService.getGroupByPhoneNumbers(value.map(x => x.PhoneNumber)).then((res) => {
                    setGroups(res.data.map(x => { return { GroupId: x.id, GroupName: x.name, PhoneNumber: x.partationKey } }))
                }).catch((err) => {

                })
            }
        } else {
            setPhoneNumbersError("Phone number can not be blank")
            SetSelectedPhonenumbers([])
        }
    }

    const onIconChange = (e) => {
        const file = e.target.files?.[0];
        if (file !== undefined) {
            let url = URL.createObjectURL(file);
            var pattern = /image-*/;
            if (!file.type.match(pattern)) {
                return;
            }
            setUploadLogo({ File: file, Url: url })
            setIcon(undefined)
        }
    }

    const handleClearLogo = () => {
        setUploadLogo(undefined)
        setIcon(undefined)
    }

    const privacyPolicyChange = (value: string) => {
        setPrivacyUrl(value)
        if (value && !UtilityService.isValidUrl(value)) {
            setPrivacyUrlError("Please enter valid url")
        } else {
            setPrivacyUrlError("")
        }
    }

    const termsUrlChanges = (value: string) => {
        setTermsServiceUrl(value)
        if (value && !UtilityService.isValidUrl(value)) {
            setTermsServiceUrlError("Please enter valid url")
        } else {
            setTermsServiceUrlError("")
        }
    }

    const titlechange = (value: string) => {
        setTitle(value)
        if (!value) {
            setTitleError("Title can not be blank")
        } else {
            value?.length > 15 ? setTitleError("Title should not exceed 15 characters") :
                setTitleError("")
        }
    }

    const descriptionChange = (value: string) => {
        setDescription(value)
        if (!value) {
            setDescriptionError("Description can not be blank")
        } else {
            value.length > 100 ? setDescriptionError("Description should not exceed 100 characters") :
                setDescriptionError("")
        }
    }

    const buttonLabelChange = (value: string) => {
        setButtonLabel(value)

        value.length > 20 ? setButtonLabelError("Button label should not exceed 20 characters") : setButtonLabelError("")

    }
    const handleButtonLabelBlur = () => {
        if (!buttonLabel.trim()) {
            setButtonLabel("Subscribe");
            setButtonLabelError("")
        }
    };

    const formSubmit = (status: number) => {

        status === WebFormStatus.Draft ? setIsLoadingDraft(true) : setIsLoadingPublish(true)
        const formData = new FormData();

        formData.append("Id", id);
        formData.append("Title", title);
        formData.append("Description", description);
        formData.append("PrivacyPolicyUrl", privacyUrl);
        formData.append("TermsConditionUrl", termsServiceUrl);
        formData.append("ButtonLabel", buttonLabel);
        formData.append("Status", status.toString());
        selectedPhonenmbers.forEach((num, index) => {
            formData.append(`PhoneNumbers[${index}]`, num);
        });
        selectedFields.forEach(x => {
            formData.append("FieldIdsOrder", x.Id);
        });
        selectedGroups.forEach((item, index) => {
            formData.append(`SelectedGroups[${index}].GroupId`, item.GroupId);
            formData.append(`SelectedGroups[${index}].GroupName`, item.GroupName);
            formData.append(`SelectedGroups[${index}].PhoneNumber`, item.PhoneNumber);
        });
        if (!!uploadLogo?.File) {
            formData.append("ImageFile", uploadLogo.File);
        }

        selectedFields.filter(x => !!x.Reference).forEach((item, index) => {
            formData.append(`CustomContactAttributes[${index}].Id`, item.Id);
            formData.append(`CustomContactAttributes[${index}].Name`, item.Name);
            formData.append(`CustomContactAttributes[${index}].Reference`, item.Reference);
            formData.append(`CustomContactAttributes[${index}].IsDeleted`, String(item.IsDeleted ?? false));
            formData.append(`CustomContactAttributes[${index}].Type`, item.Type.toString());
            formData.append(`CustomContactAttributes[${index}].Description`, item.Description);
            formData.append(`CustomContactAttributes[${index}].IsRequired`, String(item.IsRequired));

            if (item.Type === CustomAttributeType.Dropdown && item.OptionsDetail?.length) {
                item.OptionsDetail.forEach((opt, optIndex) => {
                    formData.append(`CustomContactAttributes[${index}].Options[${optIndex}].Id`, opt.id);
                    formData.append(`CustomContactAttributes[${index}].Options[${optIndex}].Label`, opt.label);
                    formData.append(`CustomContactAttributes[${index}].Options[${optIndex}].IsDeleted`, "false");
                });
            }
        });

        if (!!id) {
            const imageCleared = !!props.WebForm?.Logo && (!!uploadLogo?.Url || !Icon?.ID);
            WebFormService.updateWebForm(formData, imageCleared).then((res) => {
                props.onClose();
                status === WebFormStatus.Draft ? setIsLoadingDraft(false) : setIsLoadingPublish(false)
                setToast(ToasterTexts.WEBFORM_EDIT_SUCCESS.replace('<Name>', title), ToasterType.SUCCESS)

            }).catch((err) => {
                status === WebFormStatus.Draft ? setIsLoadingDraft(false) : setIsLoadingPublish(false)
                setToast(ToasterTexts.SOMETHING_WENT_WRONG_ERROR, ToasterType.DANGER)
                console.log(err)
            })
        } else {
            WebFormService.createWebForm(formData).then((res) => {
                status === WebFormStatus.Draft ? setIsLoadingDraft(false) : setIsLoadingPublish(false)
                setToast(ToasterTexts.WEBFORM_CREATE_SUCCESS.replace('<Name>', title), ToasterType.SUCCESS)
                props.onClose();
            }).catch((err) => {
                status === WebFormStatus.Draft ? setIsLoadingDraft(false) : setIsLoadingPublish(false)
                setToast(ToasterTexts.SOMETHING_WENT_WRONG_ERROR, ToasterType.DANGER)
                console.log(err)
            })
        }
    }

    const isValid = () => {
        let valid = true;
        valid = !!title && !!description && !!selectedPhonenmbers?.length && !titleError && !descriptionError && !privacyUrlError && !termsServiceUrlError && !phoneNumbersError && !buttonLabelError;
        return valid;
    }    
    return (
        <div className={`d-flex justify-between flex-direction w-p-100 h-p-98 ${IsDarkMode ? 'bg-color-primary-background' : 'bg-color-report-background'} border-primary-divider`}>
            <div className={`w-p-100 mx-auto d-flex justify-between  ${IsMobileDevice ? "flex-direction h-p-90 o-y-scroll" : "h-p-100"}`}>
                <div className={`d-flex flex-direction  mx-auto bb-primary-divider-top  ${IsMobileDevice ? "w-p-90" : "w-p-48 h-p-98"}`}>
                    <div className='d-flex justify-between my-2 h-p-15'>
                        <div className='d-flex justify-center flex-direction'>
                            <div className='h3-medium'>
                                Create Web Form
                            </div>
                            <div className='h5-regular'>
                                Collect contacts straight into a group with a shareable opt-in form.
                            </div>
                        </div>
                        <div className='d-flex align-center justify-flex-end mr-3'>
                            <ButtonComponent ButtonLabel={buttonLabels.CANCEL} Variant={'secondary-btn-small'} ClassName='mr-2' OnClick={() => props.onClose()} />
                            <ButtonComponent ButtonLabel={buttonLabels.SAVE} Variant={isValid() ? 'primary-btn-small' : 'disabled-btn-small'} ClassName='mr-2' OnClick={() => formSubmit(WebFormStatus.Draft)} Loading={isLoadingDraft} />
                            <ButtonComponent ButtonLabel={buttonLabels.PUBLISH} Variant={isValid() ? 'primary-btn-small' : 'disabled-btn-small'} OnClick={() => formSubmit(WebFormStatus.Published)} Loading={isLoadingPublish} />
                        </div>
                    </div>

                    <div className='h-p-80 o-y-scroll'>
                        <div className={`w-p-90 my-2 br-3 px-3 py-2 border-primary-divider ${IsDarkMode ? 'bg-color-primary-background' : 'bg-color-secondary'} `}>
                            <div className="h4-medium color-primary-accent mb-2">Select Phone Number*</div>
                            <div className='h5-regular color-primary-accent'></div>
                            <Autocomplete
                                size='small'
                                disablePortal
                                disableClearable
                                // multiple
                                options={PhoneNumbersData}
                                className={"bg-color-secondary c-pointer"}
                                getOptionLabel={(option) => UtilityService.maskPhoneNumberOnLength(option?.PhoneNumber) + ` (${option?.Name})`}
                                // value={PhoneNumbersData.filter(option => selectedPhonenmbers?.includes(option.PhoneNumber))}
                                // onChange={(event: any, value: PhoneNumberModel[] | null) => {
                                //     handleSelectedPhoneNumbers(value)
                                // }}
                                value={PhoneNumbersData.find(option => selectedPhonenmbers?.includes(option.PhoneNumber))}
                                onChange={(event: any, value: PhoneNumberModel | null) => {
                                    handleSelectedPhoneNumbers(value)
                                }}
                                renderOption={(defaultprops, option: any, { selected }) => (
                                    <li {...defaultprops} className={`${defaultprops.className}  c-pointer h2 d-flex justify-between w-p-90 py-1 px-2 `}>
                                        <div >{option?.Name} </div>
                                        <div> {UtilityService.maskPhoneNumberOnLength(option?.PhoneNumber)}</div>
                                    </li>
                                )}
                                renderInput={(params) => <TextField {...params} label="Select phone number" />}
                                sx={{
                                    "& .MuiChip-root": {
                                        backgroundColor: "var(--color-web-form-autocomplete-chip-bg)",
                                        color: "var(--color-primary-light)",
                                    },
                                    "& .MuiChip-deleteIcon": {
                                        color: "var(--color-primary-light)",
                                    },
                                }}
                            />
                            <div className='color-primary-danger h6-regular float-right'>{phoneNumbersError}</div>

                            <div className='d-flex align-center'>
                                <div>
                                    <div className="h4-medium color-primary-accent mt-2">Destination Group</div>
                                    <div className='h5-regular color-primary-accent mb-1'>Contacts from this form will be added to the selected group.</div>
                                </div>
                            </div>
                            <div className="h4-regular color-primary-accent my-1">Select Groups</div>

                            <Autocomplete
                                size='small'
                                multiple
                                disablePortal
                                options={groups.filter(x => !selectedGroups?.some(sel => sel.GroupId === x.GroupId))}
                                className={"bg-color-secondary c-pointer"}
                                getOptionLabel={(option) => UtilityService.maskPhoneNumberOnLength(option?.PhoneNumber) + ` (${option?.GroupName})`}
                                value={groups.filter(option => selectedGroups?.some(x => x.GroupId === option.GroupId))}
                                onChange={(event: any, value) => {
                                    if (value) {
                                        setSelectedGroups(value)
                                    } else {
                                        setSelectedGroups([])
                                    }
                                }}
                                renderOption={(defaultprops, option: any) => (
                                    <li {...defaultprops} className={"c-pointer h2 d-flex justify-between w-p-90 py-1 px-2"}>
                                        <div >{UtilityService.trimMessage(option?.GroupName, 20)} </div>
                                        <div> {UtilityService.maskPhoneNumberOnLength(option?.PhoneNumber)}</div>
                                    </li>
                                )}
                                renderInput={(params) => <TextField {...params} label="Select groups" />}
                                sx={{
                                    "& .MuiChip-root": {
                                        backgroundColor: "var(--color-web-form-autocomplete-chip-bg)",
                                        color: "var(--color-primary-light)",
                                    },
                                    "& .MuiChip-deleteIcon": {
                                        color: "var(--color-primary-light)",
                                    },
                                }}
                            />
                        </div>

                        <div className={`w-p-90 my-2 br-2 px-3 py-2 border-primary-divider ${IsDarkMode ? 'bg-color-primary-background' : 'bg-color-secondary'}`}>
                            <div className="h4-medium color-primary-accent">Appearance</div>
                            <div className='color-primary-accent h5-regular'>Branding shown at the top of the form.</div>
                            <div className='h5-regular color-primary-accent mt-1'>Form Title*</div>
                            <TextField
                                size='small'
                                className='w-p-100'
                                onChange={(e) => titlechange(e.target.value)}
                                value={title}
                            />
                            <div className='color-primary-danger h6-regular float-right'>{titleError}</div>
                            <div className='h5-regular color-primary-accent mt-1'>Description*</div>
                            <TextField
                                size='small'
                                className='w-p-100'
                                onChange={(e) => descriptionChange(e.target.value)}
                                value={description}
                            />
                            <div className='color-primary-danger h6-regular float-right'>{descriptionError}</div>
                            <div className='h5-regular color-primary-accent mt-1'>Button Label</div>
                            <TextField
                                size='small'
                                className='w-p-100'
                                onChange={(e) => buttonLabelChange(e.target.value)}
                                value={buttonLabel}
                                onBlur={handleButtonLabelBlur}
                            />
                            <div className='color-primary-danger h6-regular float-right'>{buttonLabelError}</div>

                            <div className='d-flex w-p-100 justify-between'>
                                <div className='w-p-49'>
                                    <div className='h5-regular color-primary-accent mt-1'>Privacy policy URL</div>
                                    <TextField
                                        size='small'
                                        className='w-p-100'
                                        onChange={(e) => privacyPolicyChange(e.target.value)}
                                        value={privacyUrl}
                                    />
                                    <div className='color-primary-danger h6-regular float-right'>{privacyUrlError}</div>
                                </div>
                                <div className='w-p-49'>
                                    <div className='h5-regular color-primary-accent mt-1'>Terms of Service URL</div>
                                    <TextField
                                        size='small'
                                        className='w-p-100'
                                        onChange={(e) => termsUrlChanges(e.target.value)}
                                        value={termsServiceUrl}
                                    />
                                    <div className='color-primary-danger h6-regular float-right'>{termsServiceUrlError}</div>
                                </div>
                            </div>
                            <div className='h5-regular color-primary-accent mt-1'>Logo</div>
                            <div className={`align-center p-2 ${(!Icon?.Url && !uploadLogo?.Url) ? "justify-center" : ""} my-1 import-contacts-border bg-color-report-background d-flex br-2 ${!uploadLogo?.Url && "c-pointer"}`}
                                onClick={() => {
                                    if (!uploadLogo?.Url) {
                                        iconRef.current?.click();
                                    }
                                }}>
                                {
                                    (!Icon?.Url && !uploadLogo?.Url) ? <div >
                                        <UploadFileIcon />
                                        <input
                                            id="Upload"
                                            type="file"
                                            name='fileupload'
                                            ref={iconRef}
                                            className="p-absolute t-0 l-0 opacity-0 c-pointer"
                                            onChange={onIconChange}
                                            accept={"image/*"}
                                        />
                                    </div> :
                                        <div className='d-flex align-center justify-between h5-medium w-p-100'>
                                            <div className='d-flex align-center mr-2'>
                                                <Avatar ImgSrc={(Icon?.Url || uploadLogo?.Url)} Name={Icon?.Name || uploadLogo?.File?.name} />
                                                <span className='ml-1'>{Icon?.Name || uploadLogo?.File?.name}</span>
                                            </div>
                                            <span className='border-primary-divider h4-regular br-2 p-1 c-pointer color-text-field-label' onClick={() => handleClearLogo()}>Remove</span>
                                        </div>
                                }
                            </div>
                        </div>

                        <div className={`w-p-90  br-2 px-3 py-3 border-primary-divider ${IsDarkMode ? 'bg-color-primary-background' : 'bg-color-secondary'}`}>
                            <div className="h4-medium color-primary-accent mb-2">Fields</div>

                            <div className={`d-flex flex-direction br-2 `}>
                                {
                                    selectedFields.map((x, index) => renderFieldRow(x, index, 'selected', false))
                                }
                            </div>

                            <div className="h4-medium color-primary-accent my-1">Unselected fields</div>
                            <div className={`d-flex flex-direction br-2 `}>
                                {unSelectedFields.length === 0
                                    ? renderEmptyDropZone('unselected')
                                    : unSelectedFields.map((x, index) =>
                                    (
                                        <div key={x.Id} className={`d-flex align-center mt-1 py-1 px-2 br-2 bb-primary-divider-2 bg-color-report-background`}>
                                            <Avatar Size={30} Index={index} Name={x.Name} />
                                            <span className="ml-1 flex-grow-1 h5-regular color-primary-accent">
                                                {x.Name}
                                            </span>
                                            <PlusPrimaryIcon className='c-pointer' onClick={() => { addFieldToSelect(x, index) }} />
                                        </div>
                                    ))
                                }
                            </div>
                        </div>

                        <div className={`w-p-90  br-2 px-3 py-2 mt-2 border-primary-divider ${IsDarkMode ? 'bg-color-primary-background' : 'bg-color-secondary'} d-flex justify-between align-center`}>
                            <div>
                                <div className='h3-medium color-primary-accent'>Consent required to submit</div>
                                <div className='h5-regular color-primary-accent'>Recommended for TCPA compliance on SMS opt-in.</div>
                            </div>
                            <div className='disabled'>
                                <CustomSwitch checked={true} onChange={() => { }} />
                            </div>
                        </div>
                    </div>
                </div>

                <div className={`d-flex flex-direction mx-auto o-hidden ${IsMobileDevice ? "w-p-90" : "h-p-98 w-p-48"}`}>
                    <div className='h-p-10 d-flex justify-between align-center w-p-97'>
                        <div className='h3-medium t-align-center color-primary-accent'>Live Preview</div>
                        <div className='d-flex justify-center'>
                            <div className='border-primary-divider d-flex align-center br-2 p-1 c-pointer h4-regular'>
                                <div className={`${isMobilePreview ? "color-secondary bg-color-primary-light br-1" : "color-primary-accent"} d-flex align-center px-1`} onClick={() => { setIsMobilePreview(true) }}>
                                    <MobilePreviewIcon className='h-2 w-2' />
                                    <span>Mobile</span>
                                </div>
                                <div className={`${!isMobilePreview ? "color-secondary bg-color-primary-light br-1" : "color-primary-accent"} d-flex align-center px-1`} onClick={() => setIsMobilePreview(false)}>
                                    <DesktopPreviewIcon className='h-2 w-2' />
                                    <span>Desktop</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`w-p-90 flex-1 br-2 px-3 py-1 border-primary-divider d-flex flex-direction o-hidden ${IsMobileDevice ? "" : "min-h-0"} ${IsDarkMode ? 'bg-color-primary-background' : 'web-form-bg'}`}>

                        <div className={`${isMobilePreview ? `${IsMobileDevice ? "w-p-95" : "w-p-55"} br-5` : "w-p-75 br-3"} h-p-100 mx-auto border-primary-divider p-1 d-flex flex-direction o-hidden ${IsDarkMode ? 'bg-color-primary-background' : 'bg-color-report-background'}`}>
                            <div className={`d-flex flex-direction box-shadow-primary-header-shadow bg-color-secondary w-p-100 mx-auto flex-1 o-hidden ${isMobilePreview ? "br-5" : "br-3"}`}>
                                <div className='w-p-95 mx-auto d-flex flex-direction flex-1 o-hidden py-1 min-h-0' >
                                    <div className='d-flex align-center justify-center py-1'>
                                        <Avatar ImgSrc={(Icon?.Url || uploadLogo?.Url)} Name={Icon?.Name || uploadLogo?.File?.name || title || "UK"} Size={30} />
                                    </div>
                                    <div className='h4-medium color-primary-accent min-h-2 t-align-center w-break px-1'>
                                        {title}
                                    </div>
                                    <div className='h5-regular color-primary-accent min-h-3 t-align-center w-p-90 mx-auto w-break py-1'>
                                        {description}
                                    </div>

                                    <div className='flex-1 d-flex flex-direction o-y-auto mx-auto w-p-80 bg-color-secondary px-2 br-2 py-1 min-h-0'>
                                        <div>
                                            {selectedFields.filter(x => x.Id !== "Consent").map(x => {
                                                return <div key={x.Id}>
                                                    <div className='h5-regular'>{x.Name}{x.IsRequired && " *"}</div>
                                                    <TextField
                                                        size='small'
                                                        disabled
                                                        className='w-p-100'
                                                        label={(x.Type === CustomAttributeType.Boolen || x.Type === CustomAttributeType.Dropdown) ? x.Description : ""}
                                                        select={(x.Type === CustomAttributeType.Boolen || x.Type === CustomAttributeType.Dropdown)}
                                                        placeholder={x.Description}
                                                        InputProps={{
                                                            startAdornment: x.Type === CustomAttributeType.Date && (
                                                                <InputAdornment position="start">
                                                                    <DateIcon className={` d-flex align-center`} />
                                                                </InputAdornment>
                                                            ),
                                                            endAdornment: x.Type === CustomAttributeType.Email && (
                                                                <InputAdornment position="start">
                                                                    <MailIcon className={` d-flex align-center`} />
                                                                </InputAdornment>
                                                            )
                                                        }}
                                                    />
                                                </div>
                                            })}
                                        </div>
                                    </div>
                                    <div className='d-flex h6-regular py-1'>
                                        <Checkbox disabled />
                                        <div className='d-flex align-center my-auto'>
                                            <div>
                                                I agree to receive recurring automated text messages from {title} at the phone number provided. Consent is not a condition of purchase. Message & data rates may apply. Message frequency varies. Reply STOP to unsubscribe or HELP for help.
                                                {(privacyUrl || termsServiceUrl) && <> See our </>}

                                                {privacyUrl && (
                                                    <a href={privacyUrl}
                                                        target="_blank"
                                                        style={{ color: "#3663ff", textDecoration: "none" }}
                                                    >
                                                        Privacy Policy
                                                    </a>
                                                )}

                                                {privacyUrl && termsServiceUrl && <> and </>}
                                                {termsServiceUrl && (
                                                    <a href={termsServiceUrl}
                                                        target="_blank"
                                                        style={{ color: "#3663ff", textDecoration: "none" }}
                                                    >
                                                        Terms of Service
                                                    </a>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <ButtonComponent ButtonLabel={buttonLabel} Variant={'primary-btn-small'} ClassName='w-p-100 disabled ' />
                                </div>
                                <div className='h5-regular color-text-field-label h-p-4 bb-primary-divider-1 d-flex align-center justify-center'>
                                    <LockGrayIcon />
                                    <div className='ml-1'>Your information is secure</div>
                                </div>
                                <div className='d-flex align-center justify-center'>
                                    <span className='h5-regular d-flex align-center justify-center'>
                                        <span className='color-text-field-label'>Powered by</span>
                                        <a href="https://www.falkonsms.com/" target="_blank" className='d-flex align-center' style={{ textDecoration: "none" }}>
                                            <FalconLogo className='w-18 ml-1' />
                                        </a>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default WebFormViewComponent;